'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';

import BlockProductPairingsSlides from './BlockProductPairingsSlides';

const Preview = props => {
    const updatedProps = useContentfulLiveUpdates(props);
    return <BlockProductPairingsSlides {...updatedProps} />;
};

export default Preview;
